import { ZCDFlex, ZCDIcon, ZCDSpacer, ZCDTypography } from '@zencity/common-ui';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { LEGEND_COMPONENT } from '../../helpers';
import styles from './Legend.module.scss';
import { INFO_KEYS, determineLegendData } from './helpers';

interface Props {
  displayNoDataExplanation?: boolean;
}

export const Legend = (props: Props) => {
  const { displayNoDataExplanation } = props;
  const { t: translate } = useTranslation();
  const filteredLegendData = determineLegendData(displayNoDataExplanation);

  return (
    <div className={styles.root} data-testid={LEGEND_COMPONENT}>
      <ZCDFlex className={styles.content} flexDirection="column">
        <ZCDFlex flexDirection="column">
          <ZCDTypography variant="t-heading-6" color="zcd-gray-100">
            {translate('widgetGenerator.widgets.servicesBarChart.legend.title')}
          </ZCDTypography>
          <ZCDSpacer orientation="vertical" customSize={6} />
          {INFO_KEYS.map((key) => (
            <ZCDFlex key={key.text} flexDirection="row" alignItems="center">
              <div className={styles.sentimentCircle} style={{ backgroundColor: key.color }} />
              <ZCDTypography variant="t-mini">{key.text}</ZCDTypography>
            </ZCDFlex>
          ))}
        </ZCDFlex>
        <div className={styles.separator} />
        <ZCDFlex flexDirection="column">
          {filteredLegendData.map((item) => (
            <div className={styles.grid} key={item.title}>
              <ZCDFlex flexDirection="row" alignItems="center" justifyContent="center" className={styles.icons}>
                {item.iconContents
                  ? item.iconContents.map((icon) => <ZCDIcon key={icon.name} name={icon.name} color={icon.color} />)
                  : item.textContent.map((text) => (
                      <ZCDTypography key={text.text} variant="t-mini" color={text.color}>
                        {text.text}
                      </ZCDTypography>
                    ))}
              </ZCDFlex>
              <ZCDTypography className={styles.text} variant="t-mini">
                {item.title}
              </ZCDTypography>
            </div>
          ))}
        </ZCDFlex>
        <div className={styles.separator} />
        <ZCDTypography variant="t-small">
          {translate('widgetGenerator.widgets.servicesBarChart.legend.explanation')}
        </ZCDTypography>
      </ZCDFlex>
    </div>
  );
};
